import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1,0h2v0.5h-2zM-1,0.5h2.5v0.5h-2.5z' },
    {
      paint: [
        ['cow', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-3.5,-3.5h0.5v0.5h-0.5zM2,-2h0.5v0.5h-0.5zM-1,-1.5h1.5v0.5h-1.5zM1.5,-1.5h0.5v0.5h-0.5zM-1.5,-1h0.5v1h-0.5zM1,-1h0.5v1.5h-0.5zM-2,0h1v0.5h-1z',
    },
    {
      paint: 'cowSpot',
      d: 'M-0.5,-4h1v0.5h-1zM-0.5,-3.5h1.5v1h-1.5zM3,-3h0.5v1.5h-0.5zM-1.5,-2h0.5v0.5h-0.5zM3,-1.5h1v0.5h-1zM3.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'cow',
      d: 'M-3.5,-4h1.5v0.5h-1.5zM1.5,-4h1v1h-1zM-4,-3.5h0.5v0.5h-0.5zM-3,-3.5h1v1h-1zM-1.5,-3h0.5v0.5h-0.5zM1,-3h1.5v0.5h-1.5zM-2.5,-2.5h2v0.5h-2zM0,-2.5h3v0.5h-3zM-2.5,-2h0.5v0.5h-0.5zM-0.5,-2h2.5v0.5h-2.5zM2.5,-2h0.5v0.5h-0.5zM-2.5,-1.5h1v1.5h-1zM2,-1.5h0.5v0.5h-0.5zM1.5,-1h1v1h-1z',
    },
    {
      paint: [
        ['cow', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-3,-4.5h0.5v0.5h-0.5zM-1.5,-4.5h2v0.5h-2zM-4,-4h0.5v0.5h-0.5zM-2,-4h1.5v1h-1.5zM0.5,-4h1v0.5h-1zM1,-3.5h0.5v0.5h-0.5zM2.5,-3.5h0.5v1h-0.5zM-3.5,-3h0.5v1h-0.5zM-2,-3h0.5v0.5h-0.5zM-1,-3h0.5v0.5h-0.5zM-0.5,-2.5h0.5v0.5h-0.5zM-2,-2h0.5v0.5h-0.5zM-1,-2h0.5v0.5h-0.5zM-1.5,-1.5h0.5v0.5h-0.5zM0.5,-1.5h1v0.5h-1z',
    },
    { paint: 'pig', d: 'M-4.5,-3h1v1h-1zM0.5,-1h0.5v0.5h-0.5z' },
    { paint: 'trunk', d: 'M-3,0h1v0.5h-1zM1.5,0h1v0.5h-1z' },
    { paint: 'fence', d: 'M-3.5,-5h0.5v1h-0.5zM-2.5,-4.5h0.5v0.5h-0.5z' },
  ],
  pixels: 120,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1,0h2v0.5h-2zM-1,0.5h2.5v0.5h-2.5z' },
    {
      paint: [
        ['cow', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-1,-1.5h1.5v0.5h-1.5zM1.5,-1.5h0.5v0.5h-0.5zM-1.5,-1h0.5v1h-0.5zM1,-1h0.5v1.5h-0.5zM-2,0h1v0.5h-1z',
    },
    {
      paint: 'cowSpot',
      d: 'M-0.5,-4h1v0.5h-1zM-0.5,-3.5h1.5v1h-1.5zM-3.5,-3h1v1h-1zM-3.5,-2h0.5v0.5h-0.5zM-1.5,-2h0.5v0.5h-0.5zM-4,-1.5h1v0.5h-1z',
    },
    {
      paint: 'cow',
      d: 'M1.5,-4h1v0.5h-1zM1.5,-3.5h0.5v0.5h-0.5zM2.5,-3.5h0.5v0.5h-0.5zM-1.5,-3h0.5v0.5h-0.5zM1,-3h2v0.5h-2zM-2.5,-2.5h2v0.5h-2zM0,-2.5h2v0.5h-2zM2.5,-2.5h0.5v0.5h-0.5zM-2.5,-2h0.5v0.5h-0.5zM-0.5,-2h4.5v0.5h-4.5zM-2.5,-1.5h1v1.5h-1zM2,-1.5h1v0.5h-1zM1.5,-1h1.5v0.5h-1.5zM1.5,-0.5h1v0.5h-1z',
    },
    {
      paint: [
        ['cow', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-1.5,-4.5h2v0.5h-2zM-2.5,-4h2v0.5h-2zM0.5,-4h1v0.5h-1zM-3,-3.5h2.5v0.5h-2.5zM1,-3.5h0.5v0.5h-0.5zM-2.5,-3h1v0.5h-1zM-1,-3h0.5v0.5h-0.5zM3.5,-3h0.5v0.5h-0.5zM-0.5,-2.5h0.5v0.5h-0.5zM2,-2.5h0.5v0.5h-0.5zM3,-2.5h1v0.5h-1zM-2,-2h0.5v0.5h-0.5zM-1,-2h0.5v0.5h-0.5zM-1.5,-1.5h0.5v0.5h-0.5zM0.5,-1.5h1v0.5h-1zM3,-1.5h1v0.5h-1z',
    },
    { paint: 'pig', d: 'M0.5,-1h0.5v0.5h-0.5zM3,-1h1v0.5h-1zM3.5,-0.5h0.5v0.5h-0.5z' },
    { paint: 'trunk', d: 'M-3,0h1v0.5h-1zM1.5,0h1v0.5h-1z' },
    { paint: 'fence', d: 'M2,-3.5h0.5v0.5h-0.5zM3.5,-3.5h0.5v0.5h-0.5zM3,-3h0.5v0.5h-0.5z' },
  ],
  pixels: 119,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1,0h2v0.5h-2zM-1,0.5h2.5v0.5h-2.5z' },
    {
      paint: [
        ['cow', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-3.5,-3.5h0.5v0.5h-0.5zM2,-2h0.5v0.5h-0.5zM-1.5,-1.5h2v0.5h-2zM1.5,-1.5h0.5v0.5h-0.5zM-1.5,-1h0.5v1h-0.5zM1,-1h0.5v1.5h-0.5zM-2,0h1v0.5h-1z',
    },
    {
      paint: 'cowSpot',
      d: 'M-0.5,-4h1v0.5h-1zM-0.5,-3.5h2v1.5h-2zM2.5,-3.5h0.5v0.5h-0.5zM3,-3h0.5v1.5h-0.5zM3,-1.5h1v0.5h-1zM3.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'cow',
      d: 'M-3.5,-4h1.5v0.5h-1.5zM1.5,-4h1v1h-1zM-4,-3.5h0.5v0.5h-0.5zM-3,-3.5h1v1h-1zM-1.5,-3h0.5v0.5h-0.5zM2,-3h0.5v0.5h-0.5zM-3,-2.5h2.5v0.5h-2.5zM1.5,-2.5h1.5v0.5h-1.5zM-3,-2h3v0.5h-3zM1,-2h1v0.5h-1zM2.5,-2h0.5v0.5h-0.5zM-2.5,-1.5h1v1.5h-1zM2,-1.5h0.5v0.5h-0.5zM1.5,-1h1v1h-1z',
    },
    {
      paint: [
        ['cow', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-3,-4.5h0.5v0.5h-0.5zM-1.5,-4.5h2v0.5h-2zM-4,-4h0.5v0.5h-0.5zM-2,-4h1.5v1h-1.5zM0.5,-4h1v0.5h-1zM-3.5,-3h0.5v1h-0.5zM-2,-3h0.5v0.5h-0.5zM-1,-3h0.5v0.5h-0.5zM1.5,-3h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM0,-2h1v0.5h-1zM0.5,-1.5h1v0.5h-1z',
    },
    { paint: 'pig', d: 'M-4.5,-3h1v1h-1zM0.5,-1h0.5v0.5h-0.5z' },
    { paint: 'trunk', d: 'M-3,0h1v0.5h-1zM1.5,0h1v0.5h-1z' },
    { paint: 'fence', d: 'M-3.5,-5h0.5v1h-0.5zM-2.5,-4.5h0.5v0.5h-0.5z' },
  ],
  pixels: 122,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
